// Colors From Abstract
// Plus Additions which are not in abstract but are required for various components
// provided by abstract
// https://app.abstract.com/projects/eccf5040-8372-11e8-8f11-559e5336594c/branches/master/commits/5793adf048e80d95c699b2e6c6d28c37cc85cb91/files/EAA7C102-B7F9-4359-BA61-B818FE23FECC/layers/E3139781-744F-4356-A64C-27767C74356E
export enum CORPORATE_COLORS {
  RED = 'rgb(234,1,0)', // #EA0100
  BLUE = 'rgb(30, 81, 140)', // #005091
  GREEN = 'rgb(67, 150, 65)',
  LIGHT_BLUE = 'rgb(70, 150, 236)',
  DARK_BLUE = 'rgb(26, 60, 101)',
  DARK_GRAY = '#444444', // RGB(68, 68, 68)
  LIGHT_GRAY = 'rgb(239, 239, 239)', // #EFEFEF
  LIGHT_GRAY_DARK = 'rgb(111, 111, 111)', // #6F6F6F
  GRAY = 'rgb(173,173,173)', // #ADADAD
  DISABLED = 'rgb(218, 218, 218)', // #DADADA
  OUTLINE = 'rgb(218, 218, 218)', // #DADADA
  RX = '#34CB9E',
  RX_LIGHT = '#eaf9f5',
  RX_BLUE = '#006ea2',
  POSITIVE = '#009933',
  WARNING = '#F6BB14',
  ATTENTION = '#FF8A00',
  WHITE = 'rgb(255, 255, 255)',
  // Rebranding
  PRIMARY = '#ED0334',
  BACKGROUND_PRIMARY_MEDIUM = '#FCF7F7',
  BACKGROUND_PRIMARY_LOW = '#FFF6F2',
  BACKGROUND_SECONDARY_LIGHT = '#DFDCFA',
  BACKGROUND_SECONDARY_MEDIUM = '#805FE3',
  BACKGROUND_LIGHT_PRIMARY_HIGH = '#EBE5E5',
  BACKGROUND_LIGHT_PRIMARY_MAX = '#BBB5B4',
  BACKGROUND_LIGHT_NOW = '#FFEEE8',
  TEXT_PRIMARY = '#2B140E',
  CONTENT_DARK_PRIMARY_LOW = '#23181557'
}
